import {format} from 'date-fns';
import {useTranslation} from 'react-i18next';

import {Modal} from '../../../../../../../_metronic/elements/Modal';
import {KTSVG} from '../../../../../../../_metronic/helpers';
import {formatFixedNumber} from '../../../../../../shared/numberFormat';
import {getHdAvailableHa, getHdRequiredHa} from './imageTypeUtils';
import {
  getPlanetHdAccessState,
  getPlanetHdCompanyPeriodEnd,
  PLANET_HD_ACCESS_STATES,
} from './planetHdAccessModel';

const formatDate = (dateValue) => {
  if (!dateValue) {
    return '-';
  }

  const date = new Date(dateValue);

  if (Number.isNaN(date.getTime())) {
    return '-';
  }

  return format(date, 'dd/MM/yyyy');
};

const HdAccessConfirmModal = ({state, onCancel, onConfirm}) => {
  const {t} = useTranslation();
  const access = state?.access || {};
  const requiredHa = getHdRequiredHa(access);
  const availableHa = getHdAvailableHa(access);
  const periodEnd = getPlanetHdCompanyPeriodEnd(access);
  const isGeometryReconfirmation =
    getPlanetHdAccessState(access) === PLANET_HD_ACCESS_STATES.STALE;
  const titleKey = isGeometryReconfirmation
    ? 'images:hd_confirmation.reconfirm_title'
    : 'images:hd_confirmation.title';
  const descriptionKey = isGeometryReconfirmation
    ? 'images:hd_confirmation.reconfirm_description'
    : 'images:hd_confirmation.description';
  const noteKey = isGeometryReconfirmation
    ? 'images:hd_confirmation.reconfirm_note'
    : 'images:hd_confirmation.aum_note';
  const confirmKey = isGeometryReconfirmation
    ? 'images:hd_confirmation.reconfirm'
    : 'images:hd_confirmation.confirm';

  return (
    <Modal open={Boolean(state?.open)} setOpen={(open) => {
      if (!open) {
        onCancel();
      }
    }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{t(titleKey)}</h5>
            <button
              type="button"
              className="btn btn-icon btn-sm btn-active-light-primary ms-2"
              onClick={onCancel}
              disabled={state?.confirming}
              aria-label={t('common:actions.close', {defaultValue: 'Cerrar'})}
            >
              <KTSVG
                path="/media/icons/duotune/arrows/arr061.svg"
                className="svg-icon svg-icon-2x"
              />
            </button>
          </div>
          <div className="modal-body">
            <p className="mb-5">{t(descriptionKey)}</p>
            <div className="d-flex flex-column gap-3">
              <div className="d-flex justify-content-between">
                <span>{t('images:hd_confirmation.required_ha')}</span>
                <strong>{formatFixedNumber(requiredHa)} ha</strong>
              </div>
              <div className="d-flex justify-content-between">
                <span>{t('images:hd_confirmation.available_ha')}</span>
                <strong>{formatFixedNumber(availableHa)} ha</strong>
              </div>
              <div className="d-flex justify-content-between">
                <span>{t('images:hd_confirmation.period_end')}</span>
                <strong>{formatDate(periodEnd)}</strong>
              </div>
            </div>
            <div className="alert alert-light-primary mt-5 mb-0">
              {t(noteKey)}
            </div>
            {state?.error && (
              <div className="alert alert-danger mt-5 mb-0" role="alert">
                {t('images:hd_confirmation.error', {
                  defaultValue: 'No pudimos confirmar el resultado. Podés reintentar: la operación es idempotente.',
                })}
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light"
              onClick={onCancel}
              disabled={state?.confirming}
            >
              {t('images:hd_confirmation.cancel')}
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={onConfirm}
              disabled={state?.confirming}
            >
              {state?.confirming && <span className="spinner-border spinner-border-sm align-middle me-2" />}
              {t(confirmKey)}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default HdAccessConfirmModal;
